import { render, staticRenderFns } from "./HmlrClientNameMismatchSubmit.vue?vue&type=template&id=30f06ff3&"
import script from "./HmlrClientNameMismatchSubmit.vue?vue&type=script&lang=js&"
export * from "./HmlrClientNameMismatchSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports